import { create } from 'zustand';

interface Species {
  speciesId: string;
  commonName: string;
  scientificName: string;
  listingStatus: string;
  profileURL?: string;
}

interface IpacState {
  endangeredSpeciesList: Species[] | null;
  selectedSpecies: string[];
  isLoading: boolean;
  isError: boolean;
  setEndangeredSpeciesList: (data: Species[] | null) => void;
  setSelectedSpecies: (species: string[]) => void;
  setIsLoading: (loading: boolean) => void;
  setIsError: (error: boolean) => void;
}

export const useIpac = create<IpacState>((set) => ({
  endangeredSpeciesList: null,
  selectedSpecies: [],
  isLoading: false,
  isError: false,
  setEndangeredSpeciesList: (data) => set({ endangeredSpeciesList: data }),
  setSelectedSpecies: (species) => set({ selectedSpecies: species }),
  setIsLoading: (loading) => set({ isLoading: loading }),
  setIsError: (error) => set({ isError: error }),
}));
